import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=d2bf9ce0&"
import script from "./CompanyView.vue?vue&type=script&lang=js&"
export * from "./CompanyView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports